 <!-- Footer -->
 <footer id="bk-footer" class="page-footer bg_color--3 pl--150 pr--150 pl_lg--30 pr_lg--30 pl_md--30 pr_md--30 pl_sm--5 pr_sm--5">
    <!-- Start Footer Top Area -->
    <div class="bk-footer-inner pt--150 pb--30 pt_sm--100">
        <div class="container">
            <div class="row">
                
                <!-- Nuestro Objetivo -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="footer-widget text-var--2">
                        <div class="logo">
                            <a href="index.php">
                                <img src="assets/img/logo/brook-white2.png" alt="Escuela Akashica">
                            </a>
                        </div>
                        <div class="footer-inner">
                            <p>Nuestro objetivo es transmitir, practicar y enseñar herramientas de conocimiento, crecimiento personal, inteligencia y conciencia ilimitada aplicada.</p>
                        </div>
                    </div>
                </div>
                <!-- Links -->
                <div class="col-lg-2 col-md-6 col-sm-6 col-12 mt_mobile--40">
                    <div class="footer-widget text-var--2 menu--about">
                        <h2 class="widgettitle">Links</h2>
                        <div class="footer-menu">
                            <ul class="ft-menu-list bk-hover">
                                <li><a href="nosotros">Nosotros</a></li>
                                <li><a href="neuroakashico">NeuroAkashico®</a></li>
                                <li><a href="contacto">Contacto</a></li>
                                <li><a href="tienda">Tienda</a></li>
                               
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- Contacto -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                    <div class="footer-widget text-var--2 menu--contact">
                        <h2 class="widgettitle">Contacto</h2>
                        <div class="footer-address">
                            <div class="bk-hover">
                                <p>Oficinas Centrales Escuela Akashica® Avenida Río Mississippi #49, Piso 14, int. 1402 Col. Cuahtémoc C.P. 06500 Ciudad de México</p>
                                <p><a href="">contacto@escuelaakashica.com</a></p>
                                <p><a href="tel:5541600137">T. 55-41600137</a> | <a href="tel:9611811608"> 961-1811608</a></p>
                            </div>
                            <div class="social-share social--transparent text-white">
                                <a href="https://www.facebook.com/AnaSilviaCoachNeuroAkashico/" target="_blank"><i class="fab fa-facebook"></i></a>
                                <a href="https://twitter.com/AnaSilviaNeuroA" target="_blank"><i class="fab fa-twitter"></i></a>
                                <a href="https://www.instagram.com/ana_silvia_neuro_akashico/" target="_blank" ><i class="fab fa-instagram"></i></a>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Galería -->
                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                    <div class="footer-widget text-var--2 menu--instagram">
                        <h2 class="widgettitle">Galería</h2>

                        <div class="ft-instagram-list">

                            <div class="instagram-grid-wrap">

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-1.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href=""><i class="fas fa-heart"></i>1k</a>
                                                <a href=""><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-2.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-3.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-4.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-5.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                                <!-- Start Single Instagram -->
                                <div class="item-grid grid-style--1">
                                    <div class="thumb">
                                        <a href="#">
                                            <img src="assets/img/footer/footer-6.jpg" alt="Escuela Akashica">
                                        </a>
                                        <div class="item-info">
                                            <div class="inner">
                                                <a href="#"><i class="fas fa-heart"></i>1k</a>
                                                <a href="#"><i class="fas fa-comment-dots"></i>9</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Start Single Instagram -->

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <!-- Copyright Area -->
    <div class="copyright ptb--50 text-var-2">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="copyright-left text-md-left text-center">
                        <ul class="bk-copyright-menu d-flex bk-hover justify-content-center justify-content-md-start flex-wrap flex-sm-nowrap">
                            
                            <li><a href="assets/formacion-completa.jpeg" target="_blank">DESCARGA LA FORMACIÓN COMPLETA AQUÍ</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="copyright-right text-md-right text-center">
                        <p>© 2020 Akashic School Inc |<a href="https://ebanti.com/"> Aviso de privacidad.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</footer>


